var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-select-tabs"},[_c('div',{staticClass:"mc-select-tabs__bar"},_vm._l((_vm.navList),function(item,index){return _c('div',{class:_vm.tabCls(item),on:{"click":function($event){$event.stopPropagation();_vm.handleChange(index)}}},[_vm._v("\n            "+_vm._s(item.label)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"mc-select-tabs__content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-selectbox-tabs.vue